import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';
import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import { ThirdPartiesCmp_SomeOrganizations_QueryDocument } from '../queries/some-organizations.query';

export const useFindAllEnabledInternalOrganizationsQuery = (enabled = true) => {
  const { genericStatusesCodeMap } = useReferencesContext();

  return useGraphQLQuery(
    ThirdPartiesCmp_SomeOrganizations_QueryDocument,
    {
      statusId: genericStatusesCodeMap.Enabled._id,
      isInternal: true,
    } as const,
    { enabled },
  );
};
